import React from 'react';
import { Button } from '../ui/Button';
export function FinalNudge() {
  return <section className="py-20 bg-stone-900" data-id="element-86">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12 font-serif" data-id="element-88">
          You Have Two Choices Right Now:
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-89">
          {/* Choice 1 - Muted */}
          <div className="bg-stone-800/60 rounded-2xl p-8 border border-stone-700" data-id="element-90">
            <div className="text-stone-500 font-bold text-sm uppercase tracking-wider mb-4" data-id="element-91">
              Choice #1
            </div>
            <p className="text-stone-400 text-lg leading-relaxed" data-id="element-92">
              Close this page and keep doing what you've been doing. Wake up
              tomorrow with the same bloated belly, the same fatigue, the same
              frustration. Wonder why nothing ever changes.
            </p>
          </div>

          {/* Choice 2 - Highlighted */}
          <div className="bg-gradient-to-br from-amber-500/20 to-amber-600/10 rounded-2xl p-8 border-2 border-amber-500 relative overflow-hidden shadow-lg shadow-amber-500/10" data-id="element-93">
            <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/10 rounded-full blur-2xl -mr-8 -mt-8" data-id="element-94"></div>
            <div className="text-amber-400 font-bold text-sm uppercase tracking-wider mb-4 relative z-10" data-id="element-95">
              Choice #2
            </div>
            <p className="text-stone-100 text-lg leading-relaxed relative z-10" data-id="element-96">
              Invest $17 (less than a dinner out) and wake up tomorrow with a
              clear plan. Follow the 5-minute ritual. Feel your jeans loosen by
              day 3. Look in the mirror on day 7 and see the difference.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-97">
          <p className="text-xl text-stone-300 italic mb-8 font-serif" data-id="element-98">
            Which woman do you want to be?
          </p>
          <Button size="xl" showIcon={true} className="shadow-amber-500/30 shadow-xl" data-id="element-99">
            I CHOOSE CHANGE →
          </Button>
        </div>
      </div>
    </section>;
}